import { a as c } from "./ssr-window.esm.mjs";
function S(t) {
  return t === void 0 && (t = ""), t.trim().split(" ").filter((e) => !!e.trim());
}
function T(t) {
  const e = t;
  Object.keys(e).forEach((n) => {
    try {
      e[n] = null;
    } catch {
    }
    try {
      delete e[n];
    } catch {
    }
  });
}
function M(t, e) {
  return e === void 0 && (e = 0), setTimeout(t, e);
}
function v() {
  return Date.now();
}
function w(t) {
  const e = c();
  let n;
  return e.getComputedStyle && (n = e.getComputedStyle(t, null)), !n && t.currentStyle && (n = t.currentStyle), n || (n = t.style), n;
}
function x(t, e) {
  e === void 0 && (e = "x");
  const n = c();
  let r, s, a;
  const l = w(t);
  return n.WebKitCSSMatrix ? (s = l.transform || l.webkitTransform, s.split(",").length > 6 && (s = s.split(", ").map((o) => o.replace(",", ".")).join(", ")), a = new n.WebKitCSSMatrix(s === "none" ? "" : s)) : (a = l.MozTransform || l.OTransform || l.MsTransform || l.msTransform || l.transform || l.getPropertyValue("transform").replace("translate(", "matrix(1, 0, 0, 1,"), r = a.toString().split(",")), e === "x" && (n.WebKitCSSMatrix ? s = a.m41 : r.length === 16 ? s = parseFloat(r[12]) : s = parseFloat(r[4])), e === "y" && (n.WebKitCSSMatrix ? s = a.m42 : r.length === 16 ? s = parseFloat(r[13]) : s = parseFloat(r[5])), s || 0;
}
function f(t) {
  return typeof t == "object" && t !== null && t.constructor && Object.prototype.toString.call(t).slice(8, -1) === "Object";
}
function b(t) {
  return typeof window < "u" && typeof window.HTMLElement < "u" ? t instanceof HTMLElement : t && (t.nodeType === 1 || t.nodeType === 11);
}
function h() {
  const t = Object(arguments.length <= 0 ? void 0 : arguments[0]), e = ["__proto__", "constructor", "prototype"];
  for (let n = 1; n < arguments.length; n += 1) {
    const r = n < 0 || arguments.length <= n ? void 0 : arguments[n];
    if (r != null && !b(r)) {
      const s = Object.keys(Object(r)).filter((a) => e.indexOf(a) < 0);
      for (let a = 0, l = s.length; a < l; a += 1) {
        const o = s[a], u = Object.getOwnPropertyDescriptor(r, o);
        u !== void 0 && u.enumerable && (f(t[o]) && f(r[o]) ? r[o].__swiper__ ? t[o] = r[o] : h(t[o], r[o]) : !f(t[o]) && f(r[o]) ? (t[o] = {}, r[o].__swiper__ ? t[o] = r[o] : h(t[o], r[o])) : t[o] = r[o]);
      }
    }
  }
  return t;
}
function F(t, e, n) {
  t.style.setProperty(e, n);
}
function _(t) {
  let {
    swiper: e,
    targetPosition: n,
    side: r
  } = t;
  const s = c(), a = -e.translate;
  let l = null, o;
  const u = e.params.speed;
  e.wrapperEl.style.scrollSnapType = "none", s.cancelAnimationFrame(e.cssModeFrameID);
  const d = n > a ? "next" : "prev", g = (p, m) => d === "next" && p >= m || d === "prev" && p <= m, y = () => {
    o = new Date().getTime(), l === null && (l = o);
    const p = Math.max(Math.min((o - l) / u, 1), 0), m = 0.5 - Math.cos(p * Math.PI) / 2;
    let i = a + m * (n - a);
    if (g(i, n) && (i = n), e.wrapperEl.scrollTo({
      [r]: i
    }), g(i, n)) {
      e.wrapperEl.style.overflow = "hidden", e.wrapperEl.style.scrollSnapType = "", setTimeout(() => {
        e.wrapperEl.style.overflow = "", e.wrapperEl.scrollTo({
          [r]: i
        });
      }), s.cancelAnimationFrame(e.cssModeFrameID);
      return;
    }
    e.cssModeFrameID = s.requestAnimationFrame(y);
  };
  y();
}
function j(t, e) {
  e === void 0 && (e = "");
  const n = [...t.children];
  return t instanceof HTMLSlotElement && n.push(...t.assignedElements()), e ? n.filter((r) => r.matches(e)) : n;
}
function O(t, e) {
  const n = e.contains(t);
  return !n && e instanceof HTMLSlotElement ? [...e.assignedElements()].includes(t) : n;
}
function C(t) {
  try {
    console.warn(t);
    return;
  } catch {
  }
}
function P(t, e) {
  e === void 0 && (e = []);
  const n = document.createElement(t);
  return n.classList.add(...Array.isArray(e) ? e : S(e)), n;
}
function D(t, e) {
  const n = [];
  for (; t.previousElementSibling; ) {
    const r = t.previousElementSibling;
    e ? r.matches(e) && n.push(r) : n.push(r), t = r;
  }
  return n;
}
function W(t, e) {
  const n = [];
  for (; t.nextElementSibling; ) {
    const r = t.nextElementSibling;
    e ? r.matches(e) && n.push(r) : n.push(r), t = r;
  }
  return n;
}
function A(t, e) {
  return c().getComputedStyle(t, null).getPropertyValue(e);
}
function L(t) {
  let e = t, n;
  if (e) {
    for (n = 0; (e = e.previousSibling) !== null; )
      e.nodeType === 1 && (n += 1);
    return n;
  }
}
function H(t, e) {
  const n = [];
  let r = t.parentElement;
  for (; r; )
    e ? r.matches(e) && n.push(r) : n.push(r), r = r.parentElement;
  return n;
}
function I(t, e, n) {
  const r = c();
  return n ? t[e === "width" ? "offsetWidth" : "offsetHeight"] + parseFloat(r.getComputedStyle(t, null).getPropertyValue(e === "width" ? "margin-right" : "margin-top")) + parseFloat(r.getComputedStyle(t, null).getPropertyValue(e === "width" ? "margin-left" : "margin-bottom")) : t.offsetWidth;
}
export {
  H as a,
  P as c,
  v as d,
  j as e,
  I as f,
  L as h,
  S as i,
  x as j,
  f as l,
  M as n,
  A as p,
  W as q,
  D as r,
  F as s,
  _ as t,
  C as u,
  O as v,
  h as w,
  T as x
};
//# sourceMappingURL=utils.mjs.map
